import { epsClient } from './eps-client'

export type PausedState = {
  isPaused: boolean
  isPausedForActor: boolean
}

type MeResponse = {
  enrollmentToEnroll?: {
    isPaused?: boolean
    isPausedForActor?: boolean
  }
}

/**
 * Fetches the employee's paused state from the EPS BFF /me payload, normalized to a flat
 * domain object so the BFF envelope (`enrollmentToEnroll`) does not leak into the store —
 * mirroring how `employee-memberships.api.ts` returns a domain type the thunk dispatches directly.
 *
 * GET api/v1/employee-experience/employee/me — uses `epsClient` (withCredentials) so the signed
 * `access_token` cookie is sent; /me is cookie-guarded (AccessTokenAuthGuard) and does NOT accept
 * the global idToken Authorization header. The cookie is established by the EPS bridge session.
 * `isPaused` is the raw enrollment flag; `isPausedForActor` bakes in server-side exemptions.
 */
export const fetchMe = async (): Promise<PausedState> => {
  const response = await epsClient.get<MeResponse>('/api/v1/employee-experience/employee/me')
  const enrollmentToEnroll = response.data?.enrollmentToEnroll
  return {
    isPaused: enrollmentToEnroll?.isPaused === true,
    isPausedForActor: enrollmentToEnroll?.isPausedForActor === true,
  }
}
